export default "__VITE_ASSET__7uYPO$84__"